var request = require('./request');

exports.refresh = function () {
  return request.post('/auth/refresh').promise();
}
